import {
  ComponentMultiStyleConfig,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { CMFormCommentText } from "../../text";
import { hasValue } from "../../../../../lib/util/common-util";

export type FormCommentBalloonProps = {
  mainComment?: {
    userName: string;
    date: Date;
    comment: string;
  };
  replyComment?: {
    userName: string;
    date: Date;
    comment: string;
  };
} & ComponentStyleProps;

export const FormCommentBalloon = ({
  mainComment,
  replyComment,

  sx,
  ...rest
}: FormCommentBalloonProps) => {
  const styles = useMultiStyleConfig("FormCommentBalloonStyles");

  return (
    <VStack sx={{ ...styles.container, ...sx }} {...rest}>
      {hasValue(mainComment) ? (
        <CMFormCommentText
          userName={mainComment.userName}
          date={mainComment.date}
          comment={mainComment.comment}
          editable={false}
          sx={{ ...styles.mainComment, ...sx }}
          {...rest}
        />
      ) : null}
      {hasValue(replyComment) ? (
        <CMFormCommentText
          userName={replyComment.userName}
          date={replyComment.date}
          comment={replyComment.comment}
          editable={false}
          sx={{ ...styles.replyComment, ...sx }}
          {...rest}
        />
      ) : null}
    </VStack>
  );
};

export const FormCommentBalloonStyles: ComponentMultiStyleConfig = {
  parts: ["container", "mainComment", "replyComment"],
  baseStyle: {
    container: {
      maxW: "400px",

      pt: "2",
      pr: "3",
      pb: "3",
      pl: "3",

      zIndex: 10,
      alignItems: "stretch",
      bgColor: "orange.100",

      borderWidth: "1px",
      borderColor: "orange.500",
      borderRadius: "md",
      boxShadow: "md",
    },
    mainComment: {},
    replyComment: {
      pt: "10px",
      pl: "16px",

      borderTopWidth: "1px",
      borderColor: "gray.200",
    },
  },
};
